<template>
  <div>
    <div class="d-flex my-5 row border mx-2">
      <div class="d-flex flex-column">
        <div class="mx-5">آپلود فایل</div>
      </div>
      <input type="file" class="align-self-center form-control mx-5" ref="file" multiple="multiple">
      <button type="button" class="align-self-center btn btn-primary my-4 btn-block mx-5" @click="submit">ذخیره</button>

    </div>
    <div class="progress m-b-20" v-if="progress > 0 && progress < 100">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
      </div>
    </div>

    <div class="col-md-12" v-if="files!=null">
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>نام فایل</th>
              <th>دانلود فایل</th>
              <th>حذف</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr" v-for="(file, index) in files" :key="index">
              <td v-text="index + 1"></td>
              <td v-text="file.name"></td>
              <td><a :href="file.path" download class="btn btn-outline-behance">دانلود</a></td>
              <td>
                <button type="button" class="btn btn-outline-danger btn-floating" @click="deleteFile(file.id)">
                  <i class="ti-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'project.files',
  props: ['files'],
  data () {
    return {
      progress: 0,
      count: 0
    }
  },
  watch: {
    progress: function (val) {
      if (val === 100) {
        this.$parent.getFiles()
        // eslint-disable-next-line no-undef
        swal(
          'تبریک!',
          'فایل ها با موفقیت آپلود شدند!',
          'success'
          , {
            button: 'باشه'
          })
      }
    }
  },
  methods: {
    submit () {
      this.progress = 0
      if (this.$refs.file.files.length === 0) {
        // eslint-disable-next-line no-undef
        swal(
          'خطا!',
          'فایلی انتخاب نشده!',
          'warning'
          , {
            button: 'باشه'
          })
      }
      this.count = this.$refs.file.files.length
      for (var i = 0; i < this.count; i++) {
        const formData = new FormData()
        const file = this.$refs.file.files[i]
        formData.append('file', file)
        this.$send.submit('post', '/api/project/' + this.$route.params.id + '/upload/file', formData)
          .then(response => {
            this.progress += 100 / this.count
          })
      }
    },
    deleteFile (fileId) {
      this.$send.submit('delete', '/api/project/files/delete/file/' + fileId)
        .then(response => {
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'فایل  با موفقیت حذف شدند!',
            'success'
            , {
              button: 'باشه'
            })
          this.$parent.getFiles()
        })
    }
  }

}

</script>

<style>

</style>
